import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ThemeEditorModule } from '@blaze-dashboard/theme-editor-feature';
import { ComplexFilterComponent, VirtualScrollModule } from '@blaze-runtime/engine-ui-feature';
import { IntellisenseComponent } from '@blaze-shared/intellisense-feature';
import { FormatValueModule, SharedModule } from '@blaze-shared/shared-feature';
import {
  AutocompleteContentDirective,
  BlazeAutocompleteComponent,
  BlazeAutocompleteOptionDirective,
  BlazeAutocompleteTriggerDirective,
  CheckboxComponent,
  ColorPickerComponent,
  DropFileDirective,
  FilterInputComponent,
  InputMaskDirective,
  LoadingIndicatorComponent,
  ScrollerComponent,
  TooltipDirective,
} from '@blaze-shared/shared-ui';

import { BlazeTableComponent } from './blaze-table/blaze-table.component';
import { CELL_INPUT_TYPES_COMPONENTS } from './cell-input/cell-input-types';
import { CellInputComponent } from './cell-input/cell-input.component';
import { COLUMN_EDITOR_PANEL_COMPONENTS } from './column-editor-panel';
import { ColumnTagsEditorSectionComponent } from './column-tags-editor-section/column-tags-editor-section.component';
import { FIELD_INPUT_PIPES, STANDALONE_FIELD_INPUT_PIPES } from './field-input/field-input.pipe';
import { FindRecordPanelComponent } from './find-record-panel/find-record-panel.component';
import { TableColumnActionsMenuComponent } from './table-column-actions-menu/table-column-actions-menu.component';
import { TableDataGenerationPanelComponent } from './table-data-generation-panel/table-data-generation-panel.component';
import { TablePopupMenuComponent } from './table-popup-menu/table-popup-menu.component';

const STANDALONE_COMPONENTS = [
  CellInputComponent,
  ColorPickerComponent,
  ColumnTagsEditorSectionComponent,
  FilterInputComponent,
  FindRecordPanelComponent,
  LoadingIndicatorComponent,
  ScrollerComponent,
  TablePopupMenuComponent,
  TableDataGenerationPanelComponent,
  ...CELL_INPUT_TYPES_COMPONENTS,
];

@NgModule({
  imports: [
    CommonModule,
    CheckboxComponent,
    DragDropModule,
    SharedModule,
    ThemeEditorModule,
    VirtualScrollModule,
    InputMaskDirective,
    FormatValueModule,
    DropFileDirective,
    ...STANDALONE_COMPONENTS,
    ...STANDALONE_FIELD_INPUT_PIPES,
    IntellisenseComponent,
    ComplexFilterComponent,
    BlazeAutocompleteTriggerDirective,
    BlazeAutocompleteOptionDirective,
    BlazeAutocompleteComponent,
    AutocompleteContentDirective,
    TooltipDirective,
  ],
  declarations: [
    BlazeTableComponent,
    TableColumnActionsMenuComponent,
    ...COLUMN_EDITOR_PANEL_COMPONENTS,
    ...FIELD_INPUT_PIPES,
  ],
  exports: [BlazeTableComponent],
})
export class BlazeTableModule {}
